export function arqueacoesInRequest(params = {}) {
  return {
    type: '@arqueacoes/ARQUEACOES_IN_REQUEST',
    payload: { params },
  };
}

export function findArqueacao(id) {
  return {
    type: '@arqueacoes/FIND_ARQUEACAO',
    payload: { id },
  };
}

export function failedRequest() {
  return {
    type: '@arqueacoes/FAILED_REQUEST',
  };
}

export function deleteArqueacao(idarqueacao, params) {
  return {
    type: '@arqueacoes/DELETE_ARQUEACAO',
    payload: { idarqueacao, params },
  };
}

export function updateArqueacao(arqueacao, params) {
  return {
    type: '@arqueacoes/UPDATE_ARQUEACAO',
    payload: { arqueacao, params },
  };
}

export function storeArqueacao(arqueacao, params) {
  return {
    type: '@arqueacoes/STORE_ARQUEACAO',
    payload: { arqueacao, params },
  };
}

export function successInRequest(
  arqueacoes,
  page,
  pageSize,
  totalCount,
  totalPages
) {
  return {
    type: '@arqueacoes/SUCCESS_IN_REQUEST',
    payload: { arqueacoes, page, pageSize, totalCount, totalPages },
  };
}

export function successRequest(arqueacao) {
  return {
    type: '@arqueacoes/SUCCESS_REQUEST',
    payload: { arqueacao },
  };
}

export function successRemove(params) {
  return {
    type: '@arqueacoes/SUCCESS_REMOVE',
    payload: { params },
  };
}

export function recordFiltering(params) {
  return {
    type: '@arqueacoes/RECORD_FILTERING',
    payload: { params },
  };
}
